import { FC } from 'react';
import { useAppSelector } from 'redux/reduxHooks';
import { Asterix } from 'components/Form/HelperText/HelperText';

const FieldTitle: FC = ({ children }) => {
  const {
    clinicDetailsSlice: {
      clinicData: { isInsuranceRequired },
    },
  } = useAppSelector((state) => state);

  return (
    <h3>
      {children} {isInsuranceRequired && <Asterix error={'error'} />}
    </h3>
  );
};

export default FieldTitle;
